export type CoreBootStage =
  | 'idle'
  | 'core'
  | 'genome'
  | 'continuity'
  | 'awakening'
  | 'companion'
  | 'complete'

export const CORE_BOOT_STAGE_EVENT =
  'promanity:core-boot-stage'

export const PROMANITY_AUDIO_UNLOCK_EVENT =
  'promanity:audio-unlock'

export function emitCoreBootStage(
  stage: CoreBootStage
) {
  if (typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent<CoreBootStage>(
      CORE_BOOT_STAGE_EVENT,
      {
        detail: stage,
      }
    )
  )
}